import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=633e2948&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=633e2948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e2948",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldFloatingLabel: require('/builds/marketing/abstracta.academy-website/components/FieldFloatingLabel.vue').default})
